import { AppState } from "../root.reducer";

export const isAccountLoadingSelector = (state: AppState) => state.account.isLoading;
export const accountSelector = (state: AppState) => state.account.account;